import axios from 'axios';
import { SERVICES_BASE_URL, REGION_CODE, COUNTRY_CODE, LANG } from './constants';

const deviceRecoveryServices = axios.create({
    baseURL: SERVICES_BASE_URL,
    timeout: 180000,
    headers: { 
        'Accept': 'application/json',
        'Content-Type' : 'application/json',
        'countryCode': COUNTRY_CODE,
        'country': COUNTRY_CODE,
        'languageCode': LANG.toUpperCase(),
        'regionCode': REGION_CODE,
        'region': REGION_CODE,
    }
});

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    deviceRecoveryServices.interceptors.request.use(function (config) {
        config.method = "get";
        console.log(config);
        config.url = config.url === "/order/orders/list" ? "order/orders/list/123" : config.url;
        config.url = config.url === "/order/orders/summary" ? "/order/orders/summary/123" : config.url;

        if (config.headers.hasOwnProperty("DRS-Fetch-Type")) {
            const fetchType = config.headers['DRS-Fetch-Type'];
            if (fetchType) {
                config.url = "--ms-responses/" + fetchType + ".json";
            }
        }

        return config;
    }, function (error) {
        console.log(error);
    });
}

export default deviceRecoveryServices;
